// extracted by mini-css-extract-plugin
export default {"container":"no-content_container__zMG4i","content":"no-content_content__SaLXM"};